<template>
  <div class="d-flex align-items-center justify-content-center py-2">
    <button>Start</button>
    <button>Prev</button>
    <div>1-1 of 1</div>
    <button>Next</button>
    <button>Last</button>
  </div>
</template>

<script>
export default {
  name: "PaginationControlsComp",
};
</script>

<style scoped></style>
